export default "__VITE_ASSET__CUAc_$lz__"